var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoc6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_422_133202)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.31982 24.1583L8.80649 33.8557L16.3012 24.9167M54.9715 34.2967L48.4907 24.5982L40.9925 33.5383",
    stroke: "#0B132B",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5278 24.6425C50.4551 34.9325 43.0596 45.0382 33.1744 47.3552C26.2771 48.9722 19.3704 46.7718 14.6793 42.1308M8.81093 33.7332C5.76943 22.3348 13.4543 11.234 24.1176 8.73499C31.4874 7.00833 38.8573 9.63333 43.5344 14.9358",
    stroke: "#0B132B",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_422_133202"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white",
    transform: "translate(0.5 0.579956)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc6);
export default __webpack_public_path__ + "static/media/doc6.61d254d1c6f7e3b0b5c42bce971f7044.svg";
export { ForwardRef as ReactComponent };